import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { CoalService } from 'app/services/coal.service';
import { AppState } from 'app/store/app.states';
import { MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { FileService } from 'app/services/file.service';
import { EstatusEmpresa } from 'app/shared/enum.shared';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogOkComponent } from 'app/utilerias/confirm-dialog-ok/confirm-dialog-ok.component';

@Component({
  selector: 'settings-company-fiel',
  templateUrl: './company-fiel.component.html',
  styleUrls: ['./company-fiel.component.scss'],
})
export class CompanyFielComponent implements OnInit, OnChanges {
  @Input() idEmpresa;
  @Input() status;

  fileKey;
  fileCer;
  files;
  noCertificado;
  vigencia;
  cargarArchivos: boolean = false;
  loadCer: boolean = false;
  loadKey: boolean = false;
  cargando: boolean = false;

  stampForm = new FormGroup({
    contrasenia: new FormControl(null, [Validators.required]),
    cer: new FormControl(false, [Validators.required]),
    key: new FormControl(false, [Validators.required]),
    ok: new FormControl(false, [Validators.required])
  });

  constructor(
    private store: Store<AppState>,
    private coalService: CoalService,
    private snackBar: MatSnackBar,
    private fileService: FileService,
    private dialog: MatDialog
  ) {
  }
  ngOnInit(): void {
    this.getFielEmpresa();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.idEmpresa?.currentValue) {
      this.getFielEmpresa();
    }
    if (this.status === EstatusEmpresa.Prerregistro || this.status === null || this.status === undefined) {
      this.stampForm?.controls?.contrasenia?.disable();
      this.cargarArchivos = false;
      const dialogRef = this.dialog.open(ConfirmDialogOkComponent, {
        width: '450px',
        data: 'Debe completar sus datos de facturación para poder cargar sus archivos de firma electrónica.'
      });
      dialogRef.afterClosed().subscribe((result) => { });
    }
    else {
      this.stampForm?.controls?.contrasenia?.enable();
      this.cargarArchivos = true;
    }
  }

  getFielEmpresa() {
    this.clearForm();
    this.store.dispatch(MostrarSpinner());
    this.coalService.getService(`ope-empresas?filters[id]=${this.idEmpresa}&populate=ope_empresa_fiels.cer,ope_empresa_fiels.key`)
      .subscribe((res: any) => {
        //console.log("🚀 ~ CompanyFielComponent ~ .subscribe ~ res:", res)
        this.store.dispatch(OcultarSpinner());
        //let info:any[]= res.data[0]?.attributes?.ope_empresa_fiels?.data || [];
        //if(info.length>0){
        this.files = res.data[0]?.attributes?.ope_empresa_fiels?.data[0] || {};
        this.noCertificado = this.files?.attributes?.noCertificado || null;
        this.vigencia = this.files?.attributes?.fechaVigencia || null;
        let pws = this.files?.attributes?.password || null;
        let isOk = this.files?.attributes?.verificacion || false;

        this.stampForm.patchValue({
          contrasenia: pws,
          cer: false,
          key: false,
          ok: isOk
        });


      }, (error: any) => {
        this.store.dispatch(OcultarSpinner());
      })
  }

  clearForm() {
    this.loadCer = false;
    this.fileCer = null;
    this.loadKey = false;
    this.fileKey = null;
    this.stampForm.patchValue({
      contrasenia: null,
      cer: false,
      key: false,
      ok: false
    });
  }

  fileBrowseHandlerCer(file) {
    this.loadCer = true;
    this.openSnackBar("Archivo cargado correctamente");
    this.fileCer = file.file[0];
    this.stampForm.controls.cer.setValue(true);
  }

  fileBrowseHandlerKey(file) {
    this.loadKey = true;
    this.openSnackBar("Archivo cargado correctamente");
    this.fileKey = file.file[0];
    this.stampForm.controls.key.setValue(true);
  }

  uploadFile() {
    this.stampForm.markAllAsTouched();
    let check: boolean = Boolean(this.stampForm.value.ok || false);
    if (!check) {
      this.openSnackBar("Debe aceptar el acuerdo de confidencialidad.", 5000, 'fill', 'error');
      return;
    }
    if (this.stampForm.value.contrasenia == null || this.stampForm.value.contrasenia == '') {
      this.openSnackBar("Favor de ingresar la contraseña.", 5000, 'fill', 'error');
      return;
    }
    if (!this.fileCer || !this.fileKey) {
      this.openSnackBar("Favor de cargar los documentos necesarios.", 5000, 'fill', 'error');
      return;
    }

    let params = {
      data: {
        cer: this.fileCer.id,
        key: this.fileKey.id,
        idEmpresa: this.idEmpresa,
        password: this.stampForm.value.contrasenia,
        verificacion: this.stampForm.value.ok
      }
    }

    this.cargando = true;
    this.store.dispatch(MostrarSpinner());
    this.coalService.postService('ope-empresa-fiels', params)
      .subscribe((res: any) => {
        this.cargando = false;
        this.cargarArchivos = false;
        this.store.dispatch(OcultarSpinner());
        //console.log("🚀 ~ CompanyFielComponent ~ .subscribe ~ res:", res)

        let ok = Number(res?.data?.attributes?.ok || 0);
        let msj = res?.data?.attributes?.mensaje || null;
        if (ok === 1) {
          this.openSnackBar(msj || "Archivos cargados correctamente!");
        } else {
          this.openSnackBar((msj || "Ocurrió un error al procesar los archivos"), 8000, 'fill', 'error');
        }
        this.getFielEmpresa();

      }, (error: any) => {
        this.cargando = false;
        this.cargarArchivos = false;
        this.store.dispatch(OcultarSpinner());
        this.openSnackBar(error?.error?.error?.message || "Ocurrió un error al procesar los archivos", 10000);
      })
  }

  downloadFile(file) {
    this.fileService.downloadFile(file?.data[0]?.attributes?.url, file?.data[0]?.attributes?.name)
      .subscribe(() => { });
  }

  openSnackBar(
    message: string,
    duration: number = 5000,
    appearance: 'fill' | 'outline' | 'soft' = 'fill',
    type: 'info' | 'success' | 'error' = 'info'
  ): void {
    const config: MatSnackBarConfig = {
      duration: duration,
      verticalPosition: 'bottom',
      horizontalPosition: 'center',
      panelClass: [`snackbar-type-${appearance}-${type}`],
    };
    this.snackBar.open(message, 'Ok', config);
  }
}
